// Config keys
export const CFG_SITE_GLOBALS = 'site/globals'
export const CFG_SOCIAL_LINKS = 'socialLinks'
export const CFG_APP_FOOTER = 'appFooter'
export const CFG_HEADER = 'header'
export const CFG_TOP_NAV_HEADER = 'topNav/header'
export const CFG_TOP_NAV_MENU = 'topNav/menu'
export const CFG_BOTTOM_NAV_FOOTER = 'bottomNav/footer'
export const CFG_BOTTOM_NAV_MENU = 'bottomNav/menu'
export const CFG_ACCOUNT_MENU = 'accountMenu'
export const CFG_SIGN_IN = 'signIn'
export const CFG_REGISTER = 'register'
export const CFG_REGION_POPUP = 'regionPopup/region-popup'
export const CFG_UPCOMING_TRIP_DAYS_LIMIT = 90
